function Header({ invoiceType }) {
  return (
    <header className="header">
      <h1>{invoiceType}</h1>
    </header>
  );
}

export default Header;